// Written out in full: vite-plugin-runtime-env only rewrites literal `import.meta.env.VITE_*`
// references, and an unfilled runtime placeholder must read as off.
export const isTestingToolsEnabled = (): boolean =>
  import.meta.env.VITE_TESTING_TOOLS_ENABLED === 'true';
